export class ExtractorUtil {
    public static phone(raw: string, locale: 'fr'): string {
        if (typeof raw !== 'string') {
            return undefined;
        }

        raw = raw.trim().replace(/\s?\.?\-?\(?\)?/g, '');
        switch (locale) {
            case 'fr': {
                const phoneFrRegex: RegExp = new RegExp('(0[6-7][0-9]{8})', 'i');
                const result: string[] = phoneFrRegex.exec(raw);
                if (result !== null && result.length > 0 && result[0] !== null) {
                    return result[0];
                }
            }
        }

        return undefined;
    }
}
